module.exports = __webpack_public_path__ + "static/media/result_image.d72eb108.png";